import { Link } from "react-router-dom";
import { COMPLETE_SOLUTIONS } from "../../data/content";

export default function CompleteSolutions() {
  return (
    <section
      data-testid="complete-solutions"
      className="py-20 md:py-32 bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12">
          <div className="md:col-span-7">
            <div className="font-mono text-[11px] tracking-[0.25em] uppercase text-ink-muted mb-5">
              Complete property solutions
            </div>
            <h2 className="font-display text-3xl md:text-5xl text-ink leading-tight tracking-[-0.03em]">
              One studio.{" "}
              <span className="font-serif-italic font-normal text-ink-mid">
                Multiple services.
              </span>
            </h2>
          </div>
          <p className="md:col-span-5 self-end text-ink-muted leading-relaxed">
            Urban Painter can combine flooring, waterproofing and painting into
            a single scope of work. It usually saves time on site and keeps the
            sequencing clean.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {COMPLETE_SOLUTIONS.map((s, i) => (
            <article
              key={s.name}
              data-testid={`solution-${i}`}
              className="group bg-ink-mist border border-ink-line p-6 md:p-8 hover:bg-ink hover:text-white transition-colors"
            >
              <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-ink-muted group-hover:text-white/60">
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="mt-3 font-display text-2xl md:text-3xl text-ink group-hover:text-white leading-tight">
                {s.name}
              </h3>
              <p className="mt-2 font-mono text-xs md:text-sm text-ink-muted group-hover:text-white/70 tracking-wide">
                {s.combo}
              </p>
            </article>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/contact"
            data-testid="complete-solutions-cta"
            className="inline-flex items-center gap-3 bg-ink hover:bg-ink-soft text-white px-8 py-4 text-[11px] tracking-[0.25em] uppercase transition-colors"
          >
            Discuss My Project
          </Link>
        </div>
      </div>
    </section>
  );
}
